import React, { Component } from 'react';
import { Table, Panel, FormControl } from 'react-bootstrap';



class RoomConfig extends Component {
    static DERIVED_AMOUNT = "DERIVED_AMOUNT";
    static DERIVED_PERCENTAGE = "DERIVED_PERCENTAGE";

    constructor(props) {
        super(props);

        this.totalNrRooms = this.totalNrRooms.bind(this);
        this.rateCodeSelected = this.rateCodeSelected.bind(this);
        this.rateSortFunction = this.rateSortFunction.bind(this);
        this.nonDerivedRateCodeFilter = r => r.type !== RoomConfig.DERIVED_AMOUNT && r.type !== RoomConfig.DERIVED_PERCENTAGE;
    }

    totalNrRooms(roomConfig) {
        let total = 0;
        roomConfig.forEach(rc => {
            total += rc.nrRooms;
        });
        return total;
    }

    rateCodeSelected(e) {
        console.log('rate code ' + e.target.value + ' selected for room type ' + e.target.id);
        this.props.updateSelectedRateCodeId(e.target.id, e.target.value)
    }

    rateIsDerived(rate) {
        return rate.type === RoomConfig.DERIVED_AMOUNT || rate.type === RoomConfig.DERIVED_PERCENTAGE;
    }

    rateSortFunction(r1, r2) {
        if ((this.rateIsDerived(r1) && this.rateIsDerived(r2)) ||
            (!this.rateIsDerived(r1) && !this.rateIsDerived(r2))) {
            return 0;
        }
        else if (this.rateIsDerived(r1)) {
            return 1;
        }

        return -1;
    }

    render() {
        const title = (
            <h3>Rate Codes</h3>
        );
        const { rateData, roomConfig } = this.props;

        return (
            <div>
                <Panel header={title}>
                    <div className="RoomConfig-info">
                        <div>For each room type, select which rate code you want price suggestions for</div>
                        <div className="App-notice">(Derived rates are followed by (*))</div>
                    </div>
                    <Table striped>
                        <tbody>
                            <tr>
                                <th>Room Type</th>
                                <th>Rate Code</th>
                            </tr>
                            {roomConfig.map((rc, index) => rateData[rc.id] && rateData[rc.id].length > 0 &&
                                <tr key={index}>
                                    <td style={{verticalAlign: "middle"}}>{rc.name}</td>
                                    <td>
                                        <FormControl id={rc.id} style={{width: "100%", display: "inline"}}
                                                     componentClass="select"
                                                     onChange={this.rateCodeSelected}>
                                            <option disabled selected value>Select rate code...</option>
                                            {rateData[rc.id].sort(this.rateSortFunction).map(rate =>
                                                <option value={rate.id}>
                                                    {rate.name}{this.rateIsDerived(rate) ? " (*)" : ""}
                                                </option>
                                            )}
                                        </FormControl>
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </Table>
                </Panel>
            </div>
        );
    }
}

export default RoomConfig;


// WEBPACK FOOTER //
// ./src/components/RoomConfig.js